import { Grid } from '../style'
import { AspectRatio, Resize } from './style'

const CropEditor = () => {
    return (
        <Grid>
            <AspectRatio />
            <Resize />
        </Grid>
    )
}

export default CropEditor
